import { headerDataHttpClient } from 'decorators/HeaderDecorator';
import { translationProvider as sharedMonotranslationStore } from 'twain-sport-fe-mono';
import TranslationsRepository from './Translations.repository';
import TranslationsStore from './Translations.store';

export const translationsRepository = new TranslationsRepository(headerDataHttpClient);
export const translationStore = new TranslationsStore(
    translationsRepository,
    sharedMonotranslationStore,
);
